import { Component, OnInit } from '@angular/core';
import { ApplicationSubType, Inspection } from '../../shared/models/index';
import { InspectionModelService } from '../../shared/services/index';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { BaseModalPageComponent } from '../../base-modal.component';
import { ApplicationType } from '../../utils';

@Component({
    templateUrl: './new.component.html',
    standalone: false
})
export class InspectionModelNewPageComponent extends BaseModalPageComponent implements OnInit {
  inspection: Inspection;
  errorMessage: string;
  isModel = false;
  type: string;
  public processing = false;

  constructor(
    private inspectionModelService: InspectionModelService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
    this.type = this.activatedRoute.snapshot.paramMap.get('type');
  }

  initRoute(): void {}

  saveInspection(inspection: Inspection): void {
    this.processing = true;
    const params = {
      name: inspection.name,
      description: inspection.description,
      applicationSubType: +inspection.applicationSubType
    };
    if (this.currentAppType === ApplicationType.Installation && !params.applicationSubType) {
      params.applicationSubType = ApplicationSubType.ParentInstallation;
    }
    this.inspectionModelService.newModel(params).subscribe((el) => {
      this.processing = false;
      this.inspection = el;
      this.goToBack();
    });
  }

  get showSubTypes() {
    return this.type === 'children';
  }

  cancel(): void {
    this.goToBack();
  }
}
